import { render, staticRenderFns } from "./comp-float.vue?vue&type=template&id=460bca6b&scoped=true&"
import script from "./comp-float.vue?vue&type=script&lang=ts&"
export * from "./comp-float.vue?vue&type=script&lang=ts&"
import style0 from "./comp-float.vue?vue&type=style&index=0&id=460bca6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bca6b",
  null
  
)

export default component.exports